export default class PredefinedRoute {

    public static TENANTS = "tenants";
    public static MEETINGS = "meetings";
    public static EVENTS = "events";
    public static OPTIONS = "options";
    public static WORKSPACE = "workspace";

    public static FEEDBACK = "feedback";
} 
